<section [style]="sectionStyles">
  @if (labelEnabled) {
    <blaze-element-label
      [color]="props?.style?.general?.title?.color1"
      [extendInputPadding]="elementContext?.extendInputPadding"
      [fontFamily]="props?.style?.labelBlock?.fontFamily"
      [fontSize]="props?.style?.labelBlock?.fontSize"
      [fontStyle]="props?.style?.labelBlock?.fontStyle"
      [fontWeight]="props?.style?.labelBlock?.fontWeight"
      [horizontalAlign]="props?.style?.labelBlock?.align"
      [icon]="props?.content?.title?.icon"
      [iconColor]="props?.content?.title?.iconColor?.color1"
      [iconPosition]="props?.style?.labelBlock?.iconPosition"
      [iconSize]="props?.style?.labelBlock?.iconSize"
      [isUsingOldPaddingStrategy]="isUsingOldPaddingStrategy"
      [lineHeight]="props?.style?.labelBlock?.lineHeight"
      [position]="props?.style?.labelBlock?.position"
      [tooltip]="props?.content?.title?.tooltip"
      [width]="props?.style?.labelBlock?.width"
    >
      {{ labelText }}
    </blaze-element-label>
  }

  <div class="wrapper" [style]="wrapperStyles" data-cy="VideoPlayer:wrapper">
    @let url = videoUrl;
    @if (!url) {
      <img
        class="placeholder"
        [style]="videoStyles"
        src="assets/images/video.svg"
        alt="video placeholder"
        data-cy="VideoPlayer:placeholder"
      />
    } @else {
      <video
        class="player"
        [style]="videoStyles"
        [src]="videoUrl"
        playsinline
        [autoplay]="props?.content?.options?.autoplay"
        [muted]="props?.content?.options?.autoplay && props?.content?.options?.autoplayMute"
        [loop]="props?.content?.options?.loop"
        [controls]="!props?.content?.options?.hideControls"
        (click)="videoClicked($event)"
        (canplay)="canPlay()"
        (play)="playing()"
        (pause)="paused()"
        (ended)="ended()"
        data-cy="VideoPlayer:video"
      ></video>
    }
  </div>
</section>
